import PropTypes from "prop-types";
import React, { memo } from "react";
import { SUBTITLE, TITLE } from "../../Account/constants";
import getThemeClasses from "@oxygen/theme";
import { SCREEN } from "../constants/Global";

const propTypes = {
  isActive: PropTypes.bool,
  screen: PropTypes.oneOf(
    Object.keys(SCREEN).map(key => {
      return SCREEN[key];
    })
  ).isRequired,
};

const titleClasses = getThemeClasses(`
  font-weight-bold;
  font-size-10;
`);
const subTitleClasses = getThemeClasses(`
  color-darkGray;
  font-size-7.5;
  mt-1;
`);

export const PopupHeader = memo(function PopupHeader({ screen, isActive }) {
  if (!screen || !isActive) {
    return null;
  }
  const title = TITLE[screen];
  const subTitle = SUBTITLE[screen];
  return (
    <>
      <span className={titleClasses}>{title}</span>
      <div className={subTitleClasses}>{subTitle}</div>
    </>
  );
});
PopupHeader.propTypes = propTypes;
